import { CloudIconWithOverlayProps } from './components/CloudIconWithOverlay';
import getFileSpriteIconClass from './utils/getFileSpriteIconClass';
import getIconForFile, { FileIcon, getFileIconFromSprite } from './utils/getIconForFile';
import { createLazyComponent, LazyModule } from 'owa-bundling';

export {
    default as getIconCSSForAttachment,
    WellKnownFileIcon,
} from './utils/getIconCSSForAttachment';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "FileIcon", webpackPrefetch: true */ './lazyIndex')
);

export const CloudIconWithOverlay = createLazyComponent(lazyModule, m => m.CloudIconWithOverlay);

// Type - not delay loaded
export {
    CloudIconWithOverlayProps,
    FileIcon,
    getFileSpriteIconClass,
    getIconForFile,
    getFileIconFromSprite,
};
